import { useState } from 'react'
import { AuthForm, AuthFormState } from '@knots/shared-frontend'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { knotsApiSdk } from '@/lib/fetcher'
import { AuthLayout, NoAccount, useAuth } from '@/features/auth'
import { LoadingOverlay } from '@/components/ui/Loaders'
import { ErrorBoundary } from 'react-error-boundary'
import { Theme } from '@/config/app'
import { useTheme } from '@/providers/theme'
import { useAuthSearchParams, useRedirect } from '@/app/routes/Auth/hooks'
import { defaultUtmSource } from '@/config'
import { dismissAllToasts } from '@/utils/toast'

export const Login = () => {
  const { theme } = useTheme()
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  const { login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const { redirectUrl } = useAuthSearchParams()
  const redirect = useRedirect()

  return (
    <ErrorBoundary fallback={<div>Form error</div>}>
      <div className="auth-route">
        <AuthLayout
          title={t('auth.signin.title')}
          content={
            <AuthForm
              knotsApiSdk={knotsApiSdk}
              state={AuthFormState.Login}
              onError={() => {}}
              onLoginSuccess={({ access_token, stayLoggedIn }) => {
                dismissAllToasts()
                login(access_token, stayLoggedIn)
                if (redirectUrl) {
                  redirect(redirectUrl)
                } else {
                  navigate({ pathname: '/', search: location.search })
                }
              }}
              switchToForgotPassword={() =>
                navigate({
                  pathname: '/auth/forgot-password',
                  search: location.search,
                })
              }
              location={location}
              onLoading={setLoading}
              gsiButtonConfig={{ theme: theme === Theme.Light ? undefined : 'filled_black' }}
              source={defaultUtmSource}
            />
          }
          footer={<NoAccount />}
        />
        <LoadingOverlay loading={loading} />
      </div>
    </ErrorBoundary>
  )
}
